export default class UserAgent {
    constructor(userAgent) {
        const [a,b,c] = userAgent.split(" ")
        const [app_name, version_name, version_code] = a.split("/")
        const [os, os_version_name, os_version_code] = b.split("/")
        this.version_code = version_code;
        this.os = os;
        this.device_model = c
    }
}